module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2086/plan1-2-793fd6118ee969de07343dcb04075d35.webp";